import { useSelector } from 'react-redux';
import { useGetProfessionalCampaigns } from '../../../../../domain/Campaigns';

/**
 * Resolves the professional being viewed (from Redux) and fetches their
 * campaign eligibilities, keeping CampaignsTabScreen presentational.
 *
 * `professionalId` is returned alongside the query so the screen can tell
 * "the profile hasn't loaded the user yet" apart from "this professional has
 * no campaigns" — the query is disabled in the first case, which would
 * otherwise look identical to an empty result.
 */
export const useProfessionalCampaigns = () => {
  const professionalId = useSelector((state) => state.users.currentUser?.id);

  return {
    professionalId,
    ...useGetProfessionalCampaigns(professionalId),
  };
};
